import { css } from 'styled-components';

const SharedGridStyle = css`
  grid-row-start: 1;
  grid-column-start: 1;
`;

export default SharedGridStyle;
